<style lang="less">
    .app{
        display: inline-block;
        margin-right:20px;
        margin-bottom:20px;
        /*border:1px solid #c8c8c8;*/
        padding:20px;
        background: #FF5F5F;
        color:white;
        cursor: pointer;

        &:hover{
            color:white;
        }

    }
</style>
<template>
    <div>
        <card style="height:600px;padding:20px;">
            <router-link class="app" to="/signup/index">预约报名</router-link>
            <div class="app" @click="gotoSurvey">调查问卷</div>
        </card>
    </div>
</template>
<script>
  export default {
    name: 'plugins_index',
    components: {
    },
    data() {
      return {
        surveyWinShown:false
      }
    },
    methods: {
      gotoSurvey(){
        window.open('https://wj.qq.com');
      }
    },
    mounted(){
    }
  }
</script>
